import PropTypes from 'prop-types'
import React, { Component } from 'react'

class CheckBoxes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checkBoxErrors: props.checkBoxErrors,
    }
  }

  validateCheckBox(name, checked) {
    const { checkBoxErrors } = this.state
    checkBoxErrors[name] = checked ? '' : 'error'
    this.setState({ checkBoxErrors })
  }

  decodeHtml(html) {
    const txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }

  render() {
    const t = this
    return (
      <div>
        {Object.keys(this.props.checkBoxes).map(name => {
          const checkbox = this.props.checkBoxes[name]
          return (
            <div
              className={this.state.checkBoxErrors[name]}
              key={name}
              style={{
                display: checkbox.hidden ? 'none' : 'block',
                margin: '15px 0px',
              }}
            >
              <label className="r-checkbox list long">
                <input
                  defaultChecked={this.props.checkBoxes[name].accepted}
                  name={name}
                  onChange={event => {
                    t.props.checkBoxOnChangeAction({
                      accepted: event.target.checked,
                      name,
                    })
                    if (!checkbox.optional) {
                      t.validateCheckBox(name, event.target.checked)
                    }
                  }}
                  type="checkbox"
                />
                <span className="check"></span>
                {checkbox.title ? (
                  <div className="paragraph bold">
                    {this.decodeHtml(checkbox.title)}
                  </div>
                ) : null}
                {checkbox.text ? (
                  <div className="paragraph">
                    {this.decodeHtml(checkbox.text)}
                  </div>
                ) : null}
              </label>
            </div>
          )
        })}
      </div>
    )
  }
}

CheckBoxes.propTypes = {
  checkBoxes: PropTypes.object.isRequired,
  checkBoxErrors: PropTypes.object.isRequired,
  checkBoxOnChangeAction: PropTypes.func.isRequired,
}

export default CheckBoxes
